<template>
  <div>
    <RightDetail
      v-if="pageStatus === 'rightDetail'"
      :toDetailData="toDetailData"
      @changeToLeader="changeToLeader()"
    ></RightDetail>
    <RightLeader
      v-if="pageStatus === 'leader'"
      :toLedgerData="toLedgerData"
      @changeToDetail="changeToDetail"
    ></RightLeader>
  </div>
</template>
<script>
import RightDetail from "./rightDeatail/RightDetail";
import RightLeader from "./rightLeader/RightLeader";
export default {
  name: "Right",
  components: {
    RightDetail,
    RightLeader,
  },
  data() {
    return {
      pageStatus: "leader",
      toDetailData: {},
      toLedgerData: {
        page: 1,
        pageSize: 10,
        querySubmitTime: undefined,
        queryAuditStatus: 0,
        queryCertificateNumber: undefined,
        queryCertificateAddress: undefined,
        queryObligeeName: undefined,
      },
    };
  },
  methods: {
    changeToLeader() {
      this.pageStatus = "leader";
    },
    changeToDetail(val) {
      this.toLedgerData.page = val.page;
      this.toLedgerData.pageSize = val.pageSize;
      this.toLedgerData.querySubmitTime = val.querySubmitTime;
      this.toLedgerData.queryAuditStatus = val.queryAuditStatus;
      this.toLedgerData.queryCertificateNumber = val.queryCertificateNumber;
      this.toLedgerData.queryCertificateAddress = val.queryCertificateAddress;
      this.toLedgerData.queryObligeeName = val.queryObligeeName;
      this.toDetailData = {
        webId: val.webId,
        auditStatus: val.auditStatus,
        isEditable: val.isEditable,
      };
      this.pageStatus = "rightDetail";
    },
  },
};
</script>

<style>
</style>